import { createFileRoute } from '@tanstack/react-router'

import { BrokerChangesPage } from '#/modules/fmcsa/changes-page'
import { validateListSearch } from '#/shared/lib/list-search'

export const Route = createFileRoute('/_shell/broker-changes')({
  component: BrokerChangesPage,
  validateSearch: validateListSearch,
})
